import React from 'react';
import { Grid, Link, Typography } from '@mui/material';
import { routes } from 'utils/routing';
import { makeStyles } from 'tss-react/mui';
import Image from '../common/Image';

interface OrganizationLabelProps {
  organizationInfo: any;
  index: number;
  length: number;
  disabled: boolean;
  text?: boolean;
}

const useStyles = makeStyles()((theme) => ({
  organizationProfile: {
    maxWidth: 100,
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  wrapper: {
    marginTop: 4,
    backgroundColor: 'white',
    width: 'fit-content',
    borderRadius: 8,
    padding: '2px 12px',
    '&:hover': {
      boxShadow: '0px 4px 8px 0px #22265229',
    },
  },
  imageContainer: {
    position: 'relative',
    minWidth: 28,
    minHeight: 28,
    background: 'white',
    paddingTop: '0px !important',
    paddingLeft: '0px !important',
    zIndex: 100,
    '.secondary &': {
      [theme.breakpoints.down('md')]: {
        width: 104,
        overflow: 'hidden',
        '& img': {
          borderTopRightRadius: 6,
          borderBottomRightRadius: 6,
        },
      },
    },
  },
  titleWrapper: {
    paddingTop: '0px !important',
  },
}));

const OrganizationLabel: React.FC<React.PropsWithChildren<OrganizationLabelProps>> = (props) => {
  const { organizationInfo, length, index, disabled, text } = props;
  const { classes } = useStyles();

  return text ? (
    <span key={organizationInfo.organization.id}>
      <Link
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        className={classes.organizationProfile}
        underline="none"
        {...(disabled
          ? { component: 'span', color: 'textSecondary' }
          : {
              target: '_blank',
              href: routes.organizationProfile(organizationInfo.organization.id).link,
            })}
      >
        {organizationInfo.organization.title}
      </Link>
      {index < length - 1 && ','}
    </span>
  ) : (
    <span style={{ marginRight: 8 }} key={organizationInfo.organization.id}>
      <Link
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        className={classes.organizationProfile}
        underline="none"
        {...(disabled
          ? { component: 'span', color: 'textSecondary' }
          : {
              target: '_blank',
              href: routes.organizationProfile(organizationInfo.organization.id).link,
            })}
      >
        <Grid className={classes.wrapper} container spacing={1.5} alignItems="center">
          <Grid item className={classes.imageContainer}>
            <Image
              variant="square"
              objectFit="cover"
              src={
                organizationInfo.organization.image?.original_url ||
                organizationInfo.organization.logo ||
                '/static/img/defaultOrgLogo.png'
              }
              alt={organizationInfo.organization.title}
              priority
            />
          </Grid>
          <Grid item xs className={classes.titleWrapper}>
            <Typography variant="body2" color="textPrimary" style={{ fontWeight: 500 }}>
              {organizationInfo.organization.title}
            </Typography>
          </Grid>
        </Grid>
      </Link>
    </span>
  );
};

export default OrganizationLabel;
